import React from 'react'
import LiveStream from "./liveStream"
import ArchiveStream from "./archiveStream";
import UpcomingStream from "./upcomingStream";
import { useEffect, useContext } from 'react';
import SglContext from '../SglContext'

export default function () {
    const Sgl = useContext(SglContext)
    useEffect(() => {
        document.title = "Special Events – Live Streaming"
        Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/specialevents');
        Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/specialevents');
    }, []);
    return (
        <div>
            <LiveStream />
            <UpcomingStream />
            <ArchiveStream />
        </div>
    )
}
